import { MessagesType } from "../Types"
import {
    MessageSentiment,
    MessagesAction
} from "../../Reducers/Client/MessagesReducer"
import { reportError } from "../../Helpers/Functions/sentry"
import { BadRequest } from "../../Models/Client/BadRequest"

export const successMessage = (text: string): MessagesAction => ({
    type: MessagesType.set,
    payload: {
        type: MessageSentiment.good,
        text
    }
})

export const warnMessage = (text: string): MessagesAction => ({
    type: MessagesType.set,
    payload: {
        type: MessageSentiment.warn,
        text
    }
})

export const failMessage = (text: string, error?: unknown): MessagesAction => {
    if (error !== undefined) {
        console.warn(error)
    }

    reportError(error ?? Error(`Error notification encountered: ${text}`), {
        tags: {
            "superai.notified": true
        },
        extra: { notificationText: text }
    })

    return {
        type: MessagesType.set,
        payload: {
            type: MessageSentiment.bad,
            text:
                error instanceof BadRequest ? `${text} ${error.message}` : text
        }
    }
}
